import { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useGetRallies } from "../../../../../api/jeep-rally/rally/rally.hooks";
import { filterRallies, normalizeRallies } from "../utils/rally.utils";
import RalliesHeader from "./_components/RalliesHeader";
import RalliesTable from "./_components/RalliesTable";

const RalliesListPage = () => {
  const history = useHistory();
  const { data, isLoading, isError, error } = useGetRallies();
  const [searchTerm, setSearchTerm] = useState("");

  const rallies = normalizeRallies(data);

  const filteredRallies = useMemo(() => {
    return filterRallies(rallies, searchTerm);
  }, [rallies, searchTerm]);

  const handleView = (rallyId) => {
    history.push(`/jeep-rally/rallies/view/${rallyId}`);
  };

  const handleEdit = (rallyId) => {
    history.push(`/jeep-rally/rallies/edit/${rallyId}`);
  };

  if (isLoading) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-danger py-4">
            Failed to load rallies.{" "}
            {error?.response?.data?.message || "Please try again."}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="card">
        <RalliesHeader
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          total={filteredRallies.length}
          onAddRally={() => history.push("/jeep-rally/rallies/create")}
        />
        <div className="card-body">
          {filteredRallies.length === 0 ? (
            <div className="text-center py-4">
              <p className="text-muted mb-0">No rallies found</p>
            </div>
          ) : (
            <RalliesTable
              rallies={filteredRallies}
              onView={handleView}
              onEdit={handleEdit}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default RalliesListPage;
